import { ArrowUpRightIcon } from '@langchain/untitled-ui-icons';

import { Button } from '@/design-system';

export const PricingLink = () => {
  return (
    <a
      href="https://www.langchain.com/pricing"
      target="_blank"
      rel="noopener noreferrer"
      className="w-fit"
    >
      <Button
        variant="underlined"
        color="secondary"
        rightDecorator={ArrowUpRightIcon}
      >
        Learn more about pricing
      </Button>
    </a>
  );
};
